<template>
  <el-drawer @reload="$reloadHandle"
             title="配件打印" size="55%"
             :before-close="handleClose"
             :visible.sync="drawer"
             direction="rtl"
             :modal-append-to-body="true"
             custom-class="demo-drawer"
             ref="drawer"
  >
    <div style="margin-top: 20px; text-align: center">
      <button @click="print()">打印</button>
    </div>
    <div id="print" style="width: 100%;">
      <div id="divPrint" class="print_div_style" v-for="item in dataList">
        <div class="container1">
          <div class="top2">
            <div class="wid30">
              <div class="none-class"></div>
              <!--              <vue-barcode :value="123456"-->
              <!--                           height="30"-->
              <!--                           width="1"-->
              <!--              >-->
              <!--                不支持vue-bercode-->
              <!--              </vue-barcode>-->
            </div>
            <div class="top-img2">
              <div class="title">华帝股份有限公司</div>
              <div class="title1">原厂合格配件发货单</div>
            </div>
            <div class="wid30">
              <vue-barcode :value="item.send1No"
                           height="40"
                           width="2"
              >
                不支持vue-bercode
              </vue-barcode>
            </div>
          </div>
          <div class="top2">
            <div class="div1"><span class="span1">客户名称: </span><span class="span2">{{ item.siteName }}  {{item.siteAccount}}
                </span></div>
            <div class="div2"><span class="span1">运费方式: </span><span class="span2">{{ item.domesticShippingType }}</span></div>
          </div>
          <div class="top2">
            <div class="div1"><span class="span1">申请单号: </span><span class="span2">{{ item.applyNo }}</span></div>
            <div class="div2"><span class="span1">发货单号: </span><span class="span2">{{ item.send1No }}</span></div>
            <div class="div2"><span class="span1">收费类型: </span><span class="span2">{{ item.orderType }}</span></div>
            <div class="div2"><span class="span1">订单类型: </span><span class="span2">{{ item.applyType }}</span></div>
          </div>
          <div class="top2">
            <div class="div1"><span class="span1">&nbsp;&nbsp;&nbsp;收货人: </span><span
              class="span2">{{ item.deliverMan }}</span></div>
            <div class="div2"><span class="span1">收货电话: </span><span class="span2">{{ item.deliverMobile }}</span>
            </div>
            <div class="div2"><span class="span1">申请日期: </span><span class="span2">{{ item.createTime }}</span>
            </div>
            <div class="div2"><span class="span1">审核日期: </span><span class="span2">{{ item.checkTime }}</span></div>
          </div>
          <div class="top2">
            <div class="div1"><span class="span1">收货地址: </span><span class="span3">
              {{ item.deliverProvince }}/{{ item.deliverCity }}/{{ item.deliverCounty }}/{{
                item.deliverTown
              }}/{{ item.deliverAddress }}
            </span>
            </div>
            <div><span class="span">第{{ item.currentPage }}页</span>/ <span
              class="span">共{{ item.totalPage }}页</span></div>
          </div>


          <!-- <h3>大区表现</h3> -->
          <div class="table-div">
            <table class="wid100 table-class">
              <thead class="wid100">
              <tr class="wid100">

                <th class="wid12 th-font-size">配件编码</th>
                <th class="wid16 th-font-size">配件描述</th>
                <th class="wid9 th-font-size">产品大类</th>
                <th class="wid6 th-font-size">单位</th>
                <th class="wid6 th-font-size">发货仓</th>
                <th class="wid13 th-font-size">ERP编码</th>
                <!--                <th class="wid4">货位</th>-->
                <th class="wid8 th-font-size">审批数量</th>
                <th class="wid8 th-font-size">实发数量</th>
                <th class="wid8 th-font-size">单价</th>
                <th class="wid8 th-font-size">金额</th>
                <th class="wid6 th-font-size">装箱号</th>
              </tr>
              </thead>

              <tbody>
              <tr v-for="line in item.list">
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden; font-weight: bold;">{{
                    line.partsCode
                  }}
                </td>
                <td class="td-font-size font-left"
                    style="white-space:nowrap; overflow:hidden; padding-left: 2px; padding-right: 2px">{{
                    line.partsName
                  }}
                </td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;">
                  {{ line.bigItemCategoryName }}
                </td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;">{{
                    line.unitName
                  }}
                </td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;">{{
                    line.warehouseCode
                  }}
                </td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;">
                  {{ line.erpCode }}
                </td>
                <!--                <td class="td-font-size">-->
                <!--                  {{-->
                <!--                    (line.warehousePositions && line.warehousePositions.length > 6) ?-->
                <!--                        line.warehousePositions.slice(0, 6) + '..' : line.warehousePositions-->
                <!--                  }}-->
                <!--                </td>-->
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;">{{
                    line.checkQty
                  }}
                </td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;">{{ line.qty }}</td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;"
                    v-if="currentSiteLevel != 2">{{ line.price }}
                </td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;" v-else>*</td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;"
                    v-if="currentSiteLevel != 2">{{ line.amount }}
                </td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;" v-else>*</td>
                <td class="td-font-size font-center" style="white-space:nowrap; overflow:hidden;"></td>
              </tr>

              <tr v-for="index of 40 - item.list.length" :key="index">
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
                <td class="td-font-size">&nbsp;</td>
              </tr>

              <tr>
                <th colspan="6">小计（小计是本页的合计）</th>
                <th>{{ item.currentPageCheckQty }}</th>
                <th>{{ item.currentPageQty }}</th>
                <th></th>
                <th v-if="currentSiteLevel != 2">{{ item.currentPageAmount }}</th>
                <th v-else>*</th>
                <th></th>
              </tr>

              <tr>
                <th colspan="6">合计（合计是整个订单的合计）</th>
                <th>{{ item.checkQtyAll }}</th>
                <th>{{ item.outQtyAll }}</th>
                <th></th>
                <th v-if="currentSiteLevel != 2">{{ item.outAmountAll }}</th>
                <th v-else>*</th>
                <th></th>
              </tr>

              </tbody>
            </table>
          </div>

          <!--          <div style="display: flex;">-->
          <!--            <span><span class="span4">制单人：</span>    <span class="span5">{{item.createBy}}</span>    </span>-->
          <!--            <span><span class="span4">发货人：</span>    <span class="span5"></span>    </span>-->
          <!--            <span><span class="span4">包装数量：</span>    <span class="span5"></span>    </span>-->
          <!--            <span><span class="span4">实收件数：</span>    <span class="span5"></span>    </span>-->
          <!--&lt;!&ndash;            <span style="width: 20%"><span class="span4">打印时间：</span>    <span class="span5"></span>    </span>&ndash;&gt;-->

          <!--          </div>-->

          <div class="top2">
            <div class="div1"><span class="span1">制单人: </span><span class="span2">{{ item.currentUserName }}</span>
            </div>
            <div class="div2"><span class="span1">发货人: </span><span class="span2"></span></div>
            <!--            <div class="div2"><span class="span1">发货人: </span><span class="span2">{{ item.collecter }}</span></div>-->
            <div class="div2"><span class="span1">包装件数: </span><span class="span2"></span></div>
            <!--            <div class="div2"><span class="span1">包装件数: </span><span class="span2">{{ item.allQty }}</span></div>-->
            <div class="div2"><span class="span1">实收件数: </span><span class="span2"></span></div>
          </div>

        </div>


      </div>
    </div>
  </el-drawer>
</template>

<script>
import printJS from "print-js";
import api from "@/api/projectApi";
import VueBarcode from "vue-barcode";
import {siteMixins} from "@/mixins/tabChang";


export default {
  name: "hdCollectPrint",
  props: ['multi', 'param', 'collectPrintIdList', 'queryType'],
  mixins: [siteMixins],
  components: {VueBarcode},
  created() {
    this.currentTime()

  },
  mounted() {
    this.getData();
  },
  data() {
    return {
      nowDate: null,
      formData: {},
      dataList: [],
      drawer: true,
      orderDates: []
    };

  },
  methods: {
    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth() + 1;
      let day = date.getDate();
      //如果格式是MM则需要此步骤，如果是M格式则此处注释掉
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day <= 9) {
        day = "0" + day;
      }
      let strDate = year + "-" + month + "-" + day;
      this.nowDate = strDate
    },
    getData() {
      this.$mask.open()
      this.$http.post(api.spPartsApplyHeader.printCollectUrl, {
        idList: this.collectPrintIdList,
        type: this.queryType
      }).then(res => {
        this.dataList = res.data.data
        this.$mask.close()
      }).catch(() => {
        this.$mask.close()
      })
    },
    print() {
      this.$http.post(api.spPartsApplyHeader.printCollectCountUrl, {
        idList: this.collectPrintIdList,
        type: this.queryType
      }).then(res => {
        console.log('累加打印次数成功')
      })

      printJS({
        printable: "print", // 标签元素id
        type: "html", // 打印类型
        targetStyles: ["*"],
        scanStyles: false,
        style: `@page {margin:0 10mm,size:148mm 210mm}
        * {
    font-size: 11px;
  }
table {
        border-right: 1px solid #000000;
        border-bottom: 1px solid #000000;
        text-align: center;
    }

    table th {
        border-left: 1px solid #000000;
        border-top: 1px solid #000000;
    }

    table td {
        border-left: 1px solid #000000;
        border-top: 1px solid #000000;
    }



  a {
    text-decoration: none;
    color: #08acee;
  }

  button {
    outline: 0;
  }

  img {
    border: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
  }

  li {
    list-style: none;
  }

  a {
    color: #666;
  }

  .clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
  }

  .container1 {
    width: 100%;
    //margin: 100px auto;
    //border: 1px solid #f1f1f1;
    //padding: 0 50px 10px;
    /* background-color: #e9e9e9; */
  }

  .top-img2 {
    /* display: flex; */
    position: relative;
    height: 80px;
    margin-top: 20px;
  }
  .div1{
    width: 36%;
  }

  .div2{
    width: 20%;
  }
  .img1 {
    width: 150px;
    margin-left: 100px;

  }

  .wid4 {
    width: 4%;
  }

  .wid13 {
    width: 13%;
  }

  .wid12 {
    width: 12%;
  }

  .wid16 {
    width: 16%;
   }

  .wid10 {
    width: 10%;
  }

  .wid18 {
    width: 18%;
  }

  .wid6 {
    width: 6%;
  }

   .wid8 {
    width: 8%;
  }

  .wid15 {
    width: 15%;
  }
  .wid14 {
    width: 14%;
  }
  .wid5 {
    width: 5%;
  }
    .wid30 {
    width: 30%;
  }


  .title {
    margin: 0;
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }

  .title1 {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }

  .img2 {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 50px;

  }

  .top2 {
    display: flex;
    padding: 5px;
    justify-content: space-between;
  }

  .span1 {
    display: inline-block;
    width: 60px;
  }

  .span2 {
    display: inline-block;
    // width: 150px;
  }
  .span6{
    margin-top: 5px;
    width: 200px;
  }
   .print_div_style{
   page-break-after:always;

    margin-top: 10px;
  }
  .table-div{
    text-align: center; width: 100%
  }
  .wid25{
    width:25%
  }
  .wid100{
    width: 100%;
  }
  .table-class{
    text-align: center !important;
    border-spacing: 0;
    overflow: hidden;
    table-layout : fixed;
  }
  .none-class{
  width:110px
  }
    .wid85{
    width: 85%;
  }
  .wid9 {
    width: 9%;
  }
  .td-font-size{
  font-size: 10px;
  }
  .td-font-size-small{
    font-size: 6px;
  }
  .th-font-size{
  font-size: 10px;
  }
  td{
  height: 14.5px;
  }
th{
  height: 14.5px;
  }
.font-left {
    text-align: left;
  }
  `,

        ignoreElements: ["no-print"], // 接受打印父 html 元素时应忽略的 html id 数组。
        properties: null,

      });

    },
    handleClose() {
      this.drawer = false;
      this.$emit('update:visiable', false)
    }
  },
};
</script>

<style lang="scss" scoped>
#print {
  * {
    font-size: 11px;
  }

  table {
    border-right: 1px solid #000000;
    border-bottom: 1px solid #000000;
    text-align: center;
  }

  table th {
    border-left: 1px solid #000000;
    border-top: 1px solid #000000;
    text-align: center;
  }

  table td {
    border-left: 1px solid #000000;
    border-top: 1px solid #000000;
  }

  td {
    font-size: 10px;
  }

  a {
    text-decoration: none;
    color: #08acee;
  }

  button {
    outline: 0;
  }

  img {
    border: 0;
  }

  button,
  input,
  optgroup,
  select,
  textarea {
    margin: 0;
    font: inherit;
    color: inherit;
    outline: none;
  }

  li {
    list-style: none;
  }

  a {
    color: #666;
  }

  .clearfix::after {
    clear: both;
    content: ".";
    display: block;
    height: 0;
    visibility: hidden;
  }

  .container1 {
    width: 100%;
    //margin: 100px auto;
    //border: 1px solid #f1f1f1;
    //padding: 0 50px 10px;
    /* background-color: #e9e9e9; */
  }

  .top-img2 {
    /* display: flex; */
    position: relative;
    height: 80px;
    margin-top: 20px;
  }

  .div1 {
    width: 36%;
  }

  .div2 {
    width: 20%;
  }

  .img1 {
    width: 150px;
    margin-left: 100px;

  }

  .title {
    margin: 0;
    width: 100%;
    font-size: 24px;
    font-weight: 600;
    text-align: center;
  }

  .title1 {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
  }

  .img2 {
    position: absolute;
    right: 0;
    top: 0;
    width: 80px;
    height: 50px;

  }

  .top2 {
    display: flex;
    padding: 5px;
    justify-content: space-between;
  }

  .span1 {
    display: inline-block;
    width: 60px;
  }

  .span2 {
    display: inline-block;
    // width: 150px;
  }

  .span6 {
    margin-top: 5px;
    width: 200px;
  }

  .print_div_style {
    page-break-after: always;
    padding: 5px;
    border: 1px solid #939292;
    margin-top: 10px;
  }

  .wid4 {
    width: 4%;
  }

  .wid13 {
    width: 13%;
  }

  .wid9 {
    width: 9%;
  }

  .wid16 {
    width: 16%;
  }

  .wid10 {
    width: 10%;
  }

  .wid18 {
    width: 18%;
  }

  .wid6 {
    width: 6%;
  }

  .wid5 {
    width: 5%;
  }

  .wid7 {
    width: 7%
  }

  .wid8 {
    width: 8%;
  }

  .wid15 {
    width: 15%;
  }

  .wid5 {
    width: 5%;
  }

  .wid14 {
    width: 14%;
  }

  .wid12 {
    width: 12%;
  }


  .table-div {
    text-align: center;
    width: 100%
  }

  .wid25 {
    width: 25%;
  }

  .wid30 {
    width: 30%;
  }

  .wid100 {
    width: 100%;
  }

  .table-class {
    text-align: center;
    border-spacing: 0;
    overflow: hidden;
    table-layout: fixed;
  }

  .wid85 {
    width: 85%;
  }

  .td-font-size {
    font-size: 10px;
  }

  .td-font-size-small {
    font-size: 6px;
  }

  .th-font-size {
    font-size: 10px;
  }

  td th {
    height: 14.5px;
    overflow: hidden;
    white-space: nowrap;
  }

  .font-left {
    text-align: left !important;
  }

  .font-center {
    text-align: center !important;
  }
}
</style>
